import React from 'react';
import { MultiCombo } from 'fw/forms';
import * as API from 'modules/app/API'

class StateMultiCombo extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {};
        this._isMounted = false;
    }

    completed = () => { return this._ctrl.completed(); }
    flag = () => { return this._ctrl.flag(); }

    componentDidMount = () => {
        this._isMounted = true;

        API.App.get('/query/getStates', {},
            {
                success: (r) => {
                    this._isMounted && this.setState({
                        items: r.data.items.map((item) => { return { label: item.stateName, value: item.stateCode } })
                    });
                }
            }, { block: false });
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    render() {
        return (
            <MultiCombo 
                {...this.props}
                placeholder={this.props.placeholder ? this.props.placeholder : "State(s)..."}
                items={this.state.items}
                searchable={true}
                ref={(c) => { this._ctrl = c }} />
        )
    }
}

export default StateMultiCombo;

// Mark this as a form component
StateMultiCombo.defaultProps = {
    formControl: true,
    managed: false
};



// WEBPACK FOOTER //
// ./src/areas/shared/controls/stateMultiCombo/StateMultiCombo.js